/* tslint:disable */
/* eslint-disable */
/**
 * Funnels API
 * API for managing funnels
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Courtier habilité au tunnel, avec ses paramètres de validation.
 * @export
 * @interface CourtierValidationDto
 */
export interface CourtierValidationDto {
    /**
     * 
     * @type {string}
     * @memberof CourtierValidationDto
     */
    courtierId: string;
    /**
     * Désignation de la personne morale du courtier.
     * @type {string}
     * @memberof CourtierValidationDto
     */
    nom?: string | null;
    /**
     * 
     * @type {string}
     * @memberof CourtierValidationDto
     */
    plateformeId: string;
    /**
     * 
     * @type {string}
     * @memberof CourtierValidationDto
     */
    plateformeNom?: string | null;
    /**
     * Nature de la personne morale du courtier (CRT, MIA, PIM).
     * @type {string}
     * @memberof CourtierValidationDto
     */
    nature?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof CourtierValidationDto
     */
    validationOptionnelle: boolean;
    /**
     * Valideurs dont le périmètre couvre ce courtier.
     * @type {Array<string>}
     * @memberof CourtierValidationDto
     */
    valideurIds: Array<string>;
    /**
     * true quand aucun périmètre ne couvre le courtier ; le valideur principal reçoit ses demandes.
     * @type {boolean}
     * @memberof CourtierValidationDto
     */
    repliPrincipal: boolean;
}

/**
 * Check if a given object implements the CourtierValidationDto interface.
 */
export function instanceOfCourtierValidationDto(value: object): value is CourtierValidationDto {
    if (!('courtierId' in value) || value['courtierId'] === undefined) return false;
    if (!('plateformeId' in value) || value['plateformeId'] === undefined) return false;
    if (!('validationOptionnelle' in value) || value['validationOptionnelle'] === undefined) return false;
    if (!('valideurIds' in value) || value['valideurIds'] === undefined) return false;
    if (!('repliPrincipal' in value) || value['repliPrincipal'] === undefined) return false;
    return true;
}

export function CourtierValidationDtoFromJSON(json: any): CourtierValidationDto {
    return CourtierValidationDtoFromJSONTyped(json, false);
}

export function CourtierValidationDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CourtierValidationDto {
    if (json == null) {
        return json;
    }
    return {
        
        'courtierId': json['courtierId'],
        'nom': json['nom'] == null ? undefined : json['nom'],
        'plateformeId': json['plateformeId'],
        'plateformeNom': json['plateformeNom'] == null ? undefined : json['plateformeNom'],
        'nature': json['nature'] == null ? undefined : json['nature'],
        'validationOptionnelle': json['validationOptionnelle'],
        'valideurIds': json['valideurIds'],
        'repliPrincipal': json['repliPrincipal'],
    };
}

export function CourtierValidationDtoToJSON(json: any): CourtierValidationDto {
    return CourtierValidationDtoToJSONTyped(json, false);
}

export function CourtierValidationDtoToJSONTyped(value?: CourtierValidationDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'courtierId': value['courtierId'],
        'nom': value['nom'],
        'plateformeId': value['plateformeId'],
        'plateformeNom': value['plateformeNom'],
        'nature': value['nature'],
        'validationOptionnelle': value['validationOptionnelle'],
        'valideurIds': value['valideurIds'],
        'repliPrincipal': value['repliPrincipal'],
    };
}

